module.exports = __webpack_public_path__ + "static/media/face_5.60db09dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/face_5.png
// module id = 13216
// module chunks = 0